<app-loading-overlay [isLoading]="!!isLoading"></app-loading-overlay>
<div nz-row>
  <div nz-col nzSpan="8">
    <span class="tab-title">Charts</span>
  </div>
  <div nz-col nzOffset="12" nzSpan="4">
    <button nz-button nzSize="large" (click)="openCreateChartModal()" class="green-btn">Create New Chart</button>
  </div>
</div>
<div class="charts-panel">
  <nz-table
    #chartsTable
    [nzData]="charts"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
    [nzScroll]="{ x: '98.75rem', y: 'calc(100vh - 18rem)' }"
    [nzNoResult]="noDataTemplate"
    nzSize="middle"
    nzBordered
  >
    <thead>
      <tr>
        <ng-container *ngFor="let header of headers; trackBy: trackByHeader">
          <th
            *ngIf="header.sortDirections; else nonSortableHeader"
            [nzSortDirections]="header.sortDirections"
            [nzSortOrder]="header.sortOrder"
            [nzSortFn]="header.sortFn"
            [nzRight]="header.right"
            [nzWidth]="header.width"
            [class.action-header]="header.name === 'Action'"
          >
            {{ header.name }}
          </th>
          <ng-template #nonSortableHeader>
            <th [nzWidth]="header.width" [nzRight]="header.right" [class.action-header]="header.name === 'Action'">
              {{ header.name }}
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let chart of chartsTable.data">
        <td>{{ chart.name }}</td>
        <td>{{ chart.description }}</td>
        <td>{{ chart.chartType }}</td>
        <td>{{ chart.lastModifiedAt | dateTime }}</td>
        <td>{{ chart.lastModifiedBy }}</td>
        <td nzRight>
          <div class="action-btns">
            <button nz-button nzType="text" (click)="viewChart(chart?.chartId ?? '')">
              <span nz-icon nzType="eye"></span>
            </button>
            <button nz-button nzType="text" (click)="editChart(chart?.chartId ?? '')">
              <span nz-icon nzType="edit"></span>
            </button>
            <button nz-button nzType="text" (click)="deleteChart(chart)">
              <span nz-icon nzType="delete"></span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <ng-template #noDataTemplate>No Charts</ng-template>
</div>
